const queryKeys = {
	'TICKET_INFO': 'ticket-info',
	'BBPLUS_TICKET_INFO': 'bbplus-ticket-info',
	'RESULT_DROPDOWN_LIST_NEW': 'result-dropdown-list-new',
	'RESULT_OUTRIGHT_DROPDOWN_LIST_NEW': 'result-outright-dropdown-list-new',
	'RESULT_INDEX': 'result-index',
	'RESULT_OUTRIGHT_INDEX': 'result-outright-index',
	'RESULT_TABLET_SOCCER_DETAIL': 'result-tablet-soccer-detail',
	'RESULT_TABLET_ESPORT_DETAIL': 'result-tablet-esport-detail',
	'RESULT_URL': 'result-url',
	'RESULT_AUTHORIZATION_SPORTS_LOTTERY_RESULT': 'result-authorization-sports-lottery-result',
	'RESULT_AUTHORIZATION_INDO_4D_RESULT': 'result-authorization-indo-4d-result',
	'RESULT_AUTHORIZATION_VIRTUAL_GAME_RESULT': 'result-authorization-virtual-game-result',
	'RESULT_AUTHORIZATION_BULL_FIGHTING_RESULT': 'result-authorization-bull-fighting-result',
	'RESULT_N7_LOTTO_RESULT': 'result-n7-lotto-result',
	'RESULT_CUP_MATCH_RESULT': 'result-cup-match-result',
	'RESULT_GAMES_RESULT': 'result-games-result',
	'TICKET_BET': 'ticket-bet',
	'BBPLUS_TICKET_BET': 'bbplus-ticket-bet',
	'TICKET_STATUS': 'ticket-status',
	'PARLAY_STATUS': 'parlay-status',
	'MENU_DATA': 'menu-data',
	'SAVE_SPORT_SORT': 'save-sport-sort',
	'STREAMING_INDEX': 'streaming-index',
	'STREAMING_IN_HOUSE_WITH_SECRET': 'streaming-in-house-with-secret',
	'ACCOUNT_SETTINGS': 'account-settings',
	'SAVE_ACCOUNT_SETTINGS': 'save-account-settings',
	'USER_REWADR_INFO': 'user-reward-info',
	'UNSETTLED_CATEGORY_INFO': 'unsettled-category-info',
	'UNSETTLED_BET_LIST_INFO': 'unsettled-bet-list-info',
	'UNSETTLED_STATUS_COUNT_INFO': 'unsettled-status-count-info',
	'SETTLED_CATEGORY_INFO': 'settled-category-info',
	'SETTLED_ALL_BETS_INFO': 'settled-all-bets-info',
	'SETTLED_BET_LIST_INFO': 'settled-bet-list-info',
	'RESULT_POPUP_INFO': 'result-popup-info',
	'RESULT_POPUP_INFO_V2': 'result-popup-info-v2',
	'VGAMING_RESULT_POPUP_INFO': 'vgaming-result-popup-info',
	'MESSAGES_DATA': 'messages-data',
	'MESSAGE_TOP': 'messages-top',
	'MESSAGES_CHECKDATA': 'messages=check-data',
	'MIX_PARLAY_DETAIL_INFO': 'mix-parlay-detail-info',
	'SITE_CONFIGS': 'site-configs',
	'SWITCH_MODE': 'switch-mode',
	'SKIN_MODE_URL': 'skin-mode-url',
	'COLOR_SCHEME': 'color-scheme',
	'MY_FAVOURITE_INFO': 'my-favourite-info',
	'MY_FAVOURITE_STATUS': 'my-favourite-status',
	'SEARCH_AUTOCOMPLETE': 'search-autocomplete',
	'SEARCH_HISTORY': 'search-history',
	'UPDATE_BALANCE': 'update-balance',
	'CASH_OUT_STATUS_PRICE': 'cash-out-status-price',
	'USE_TOKEN_TO_LOGIN': 'use-token-to-login',
	'CASH_OUT_HISTORY_DERAIL': 'cash-out-hietory-detail',
	'GET_SPORT_PIN_SORT': 'get-sport-pin-sort',
	'UM_MESSAGE': 'um-message',
	'GET_MARKET_BY_LEAGUE_MATCH': 'get-market-by-league-match',
	'REWARD_SYSTEM_INFO': 'reward-system-info',
	'REWARD_SYSTEM_LABELS': 'reward-system-labels',
	'FREEBET_VOUCHER_CONDITION': 'freebet-voucher-condition',
	'LIMIT_MESSAGE': 'limit-message',
	'SPREAD_SETTING': 'spread-setting',
	'PLAYER_SURVEY_IS_SUBMITTED': 'player-survey-is-submitted',
	'LEAVE_SURVEY_IS_SUBMITTED': 'leave-survey-is-submitted',
	'FETCH_CHATROOM_TOKEN': 'fetch-chatroom-token',
	'FETCH_PLUGIN_URL': 'fetch-plugin-url',
	'GET_SPORT_SORT_JSON': 'get-sport-sort-json',
	'SHOW_ALL_ODDS_FOR_MULTI_SPORT': 'show-all-odds-for-multi-sport',
	'SITE_CONFIGS_WITH_SESSION': 'site-configs-with-session',
	'GET_ESPORT_STREAMING': 'get-esport-streaming',
	'GET_STREAMING_SCHEDULE': 'get-streaming-schedule',
	'MASTER_RANKING': 'master-ranking',
	'HOT_MATCH': 'hot-match',
	'HOT_BETTING': 'hot-betting',
	'GET_NICK_NAME': 'get-nick-name',
	'SAVE_NICK_NAME': 'save-nick-name',
	'Tournament_Group': 'tournament_group',
	'Tournament_Point': 'tournament_point',
	'Tournament_Knockout': 'tournament_knockout',
	'Tournament_Country': 'tournament_country',
	'GET_THIRD_PARTY_TOKEN': 'get-third-party-token',
	'Get_Esport_Streaming': 'Get_Esport_Streaming',
	'GET_BANNER_INFO': 'get-banner-info',
	'CORRECT_SCORE_JACKPOT': 'correct-score-jackpot',
	'CORRECT_SCORE_JACKPOT_PRIZE': 'correct-score-jackpot-prize',
	'CORRECT_SCORE_JACKPOT_BYMATCH': 'correct-score-jackpot-bymatch',
	'CORRECT_SCORE_JACKPOT_ENABLE_LIST': 'correct-score-jackpot-enable-list',
	'CORRECT_SCORE_JACKPOT_DRAW_SETTING': 'correct-score-jackpot-draw-setting',
	'CORRECT_SCORE_JACKPOT_DRAW_SETTING_V2': 'correct-score-jackpot-draw-setting-v2',
	'SMP_URL': 'smp-url',
	'EXCHANGE_BALANCE': 'exchange_balance',
	'EXCHANGE_RETRIEVE': 'exchange_retrieve',
	'EXCHANGE_TRANSFER_IN': 'exchange_transfer_in',
	'VIRTUAL_SOCCER_WIDGET': 'virtual-soccer-widget',
	'WHO_AM_I': 'who_am_i',
	'ATHENA_MENU_SETTING': 'athena-menu-setting',
	'ATHENA_SITE_CONFIG': 'athena-site-config',
	'ATHENA_CUSTOM_SETTING': 'athena-custom-setting',
	'BANK_DETAIL': 'bank-detail',
	'BANK_INFO': 'bank-info',
	'MAILING_ADDRESS': 'mailing-address',
	'GET_TEMPLATE_RESOURCE': 'get_template_resource',
	'FETCH_COUNTRY_CODE_DATA': 'fetch-country-code-data',
	'FETCH_CHECK_UNIQUE_USERNAME': 'fetch-check-unique-username',
	'GET_BALANCE': 'get-balance',
	'TRANSFER_INITIAL': 'transfer-initial',
	'TRANSACTION_HISTORY': 'transaction-history',
	'TEAM_NAME_MAPPING': 'team-name-mapping',
	'GOLDEN_DUEL_SETTING': 'golden-duel-setting',
	'GOLDEN_DUEL_GROUP_BY_MATCH_ID': 'golden-duel-group-by-match-id',
	'GOLDEN_DUEL_GROUP_DATES': 'golden-duel-group-dates',
	'GOLDEN_DUEL_MATCH_GROUPS': 'golden-duel-match-groups',
	'GOLDEN_DUEL_GROUPS': 'golden-duel-groups',
	'GOLDEN_DUEL_MATCH_GROUP_DETAIL': 'golden-duel-match-group-detail',
	'GOLDEN_DUEL_MATCH_GROUP_NEXT_GAME': 'golden-duel-match-group-next-game',
	'GOLDEN_DUEL_TICKET_GROUPS': 'golden-duel-ticket-groups',
	'GOLDEN_DUEL_WINNING_NOTIFY': 'golden-duel-winning-notify',
	'CWC_JACKPOT_SETTING': 'cwc-jackpot-setting',
	'CWC_JACKPOT_ALL_GROUPS': 'cwc-jackpot-all-groups',
	'CWC_JACKPOT_MATCH_GROUPS': 'cwc-jackpot-match-groups',
	'CWC_JACKPOT_SINGLE_MATCH_GROUP': 'cwc-jackpot-single-match-group',
	'CWC_JACKPOT_MATCH_GROUP_DETAIL': 'cwc-jackpot-match-group-detail',
	'CWC_JACKPOT_WINNING_NOTIFY': 'cwc-jackpot-winning-notify',
	'CWC_JACKPOT_RULES_POPUP_VIEWED_STATUS': 'cwc-jackpot-rules-popup-viewed-status',
	'SPORTS_CONTRIBUTOR': 'sports-contributor',
	'SPORTS_EVENT_SUMMARY': 'sports-event-summary',
	'NBA_PLAYOFFS_SURVEY_IS_SUBMITTED': 'nba-playoffs-survey-is-submitted',
	'SPORT_EVENT_WIDGET_URL': 'sport-event-widget-url',
	'SPORT_EVENT_VOTE_DATA': 'sport-event-vote-data',
	'GET_SPORT_EVENT_WINNER_LIST': 'get-sport-event-winner-list',
	'GET_LIC_SETTINGS': 'get-lic-settings',
	'WC_PROMOTION_SETTING': 'wc-promotion-setting',
	'WC_PROMOTION_ALL_POOLS': 'wc-promotion-all-pools',
	'WC_PROMOTION_POOL': 'wc-promotion-pool',
	'WC_PROMOTION_POOL_PRIZE_WINNERS': 'wc-promotion-pool-prize-winners',
	'WC_PROMOTION_LOTTERYS': 'wc-promotion-lotterys',
	'WC_PROMOTION_AFTER_PARTY_TICKETS': 'wc-promotion-after-party-tickets',
	'WC_PROMOTION_LOTTERY_COUNT_BY_POOL_ID': 'wc-promotion-lottery-count-by-pool-id',
	'WC_PROMOTION_PRIZE_AMOUNT': 'wc-promotion-prize-amount',
	'WC_PROMOTION_WINNING_NOTIFY': 'wc-promotion-winning-notify',
	'WC_PROMOTION_SPIN_DAILY_INFO': 'wc-promotion-spin-daily-info',
	'WC_PROMOTION_SPIN_TASKS_COMPLETE': 'wc-promotion-spin-tasks-complete',
	'WC_PROMOTION_SPIN_DRAW': 'wc-promotion-spin-draw',
	'WC_PROMOTION_SPIN_HISTORY': 'wc-promotion-spin-history',
	'WC_SURVEY_STATUS': 'wc-survey-status',
	'WC_SURVEY_QUESTIONS': 'wc-survey-questions',
	'GET_PROMOTION_VOUCHERS': 'get-promotion-vouchers',
	'PACKAGED_MATCHES_BY_MATCH_ID': 'packaged-matches-by-match-id',
} as const;

export default queryKeys;
